import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";
import { Card } from "nectar-ui";
import { FaChevronDown } from "@react-icons/all-files/fa/FaChevronDown";
import { FaChevronUp } from "@react-icons/all-files/fa/FaChevronUp";
import { NormalText } from "@components/styles/dataDisplay";

export const MovimentItemCardBorder = styled(Card)<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacings.sm};
    align-items: center;
    width: 100%;
  `}
`;

export const MovementTitleContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    column-gap: ${theme.spacings.xs};
    row-gap: ${theme.spacings.xs};
    width: 100%;

    & > svg {
      margin-top: 4px;
    }
  `}
`;

export const MovementChevronContainer = styled.div<NectarTheme>`
  margin-left: auto;
  margin-top: 5px;
  align-self: flex-start;
`;

export const ChevronDown = styled(FaChevronDown)<NectarTheme>`
  ${({ theme }) => css`
    color: ${theme.colors.gray500};
  `}
`;

export const ChevronUp = styled(FaChevronUp)<NectarTheme>`
  ${({ theme }) => css`
    color: ${theme.colors.gray500};
  `}
`;

export const HistoricalListContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding-top: ${theme.spacings.md};
    padding-bottom: ${theme.spacings.md};
    padding-left: ${theme.spacings.md};

    > div:not(:last-child)::after {
      content: "";
      grid-area: divider;
      width: calc(100% - 24px);
      height: 1px;
      background-color: ${theme.colors.gray300};
      margin-top: ${theme.spacings.md};
      margin-bottom: ${theme.spacings.lg};
    }
  `}
`;

export const HistoricalContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.xs};
    word-break: break-word;

    ${theme.breakpoints.sm} {
      display: grid;
      grid-template-columns: 20% 80%;
      grid-template-rows: 30px auto;
      grid-template-areas:
        "date title"
        ". description"
        ". events"
        "divider divider";
    }
  `}
`;

export const BulletPointSpan = styled.span<NectarTheme>`
  ${({ theme }) => css`
    color: ${theme.colors.gray500};
  `}
`;
export const EventsContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.lg};
    padding-left: 30px;
    margin-top: 24px;
    margin-left: 30px;
    grid-area: events;
  `}
`;

export const EventItemContainer = styled.div<NectarTheme & { withLine: boolean; single: boolean }>`
  ${({ theme, withLine, single }) => css`
    display: flex;
    flex-direction: column;
    position: relative;

    ${withLine &&
    css`
      ::before {
        content: "";
        position: absolute;
        width: 1px;
        height: ${!single ? "calc(100% + 24px)" : "100%"};
        background-color: ${theme.colors.gray300};
        top: ${!single ? "15px" : "0px"};
        left: -30px;
      }
    `}
  `}
`;

export const EventTitleContainer = styled.div<NectarTheme & { single: boolean }>`
  ${({ theme, single }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    column-gap: ${theme.spacings.xs};
    row-gap: ${theme.spacings.xs};
    margin-bottom: 9px;
    align-items: flex-start;

    > span {
      display: none;
    }

    ${theme.breakpoints.sm} {
      flex-direction: row;
      align-items: center;

      > span {
        display: block;
      }
    }

    ${!single &&
    css`
      ::before {
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${theme.colors.gray300};
        position: absolute;
        top: 9px;
        left: -32px;
      }
    `}
  `}
`;

export const EventItemDescription = styled(NormalText)<NectarTheme>`
  ${({ theme }) => css`
    margin-left: 0px;

    ${theme.breakpoints.sm} {
      margin-left: 21px;
    }
  `}
`;
